/* eslint-disable no-case-declarations */
import Vue from "vue";
import Vuex from "vuex";
// import instance from '@/apiconfig'

const axios = require("axios");

axios.defaults.baseURL = process.env.VUE_APP_BASEAPI;
axios.interceptors.request.use(function(config) {
  config.headers.Authorization = localStorage.getItem("token") || "";
  config.headers.Lang =
    localStorage.getItem("setlanguage") ||
    localStorage.getItem("detectedLanguage") ||
    "en";
  return config;
});
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    history: JSON.parse(localStorage.getItem("history")),
    tags: [],
    languages: []
  },
  mutations: {
    HISTORY_SET: (state, payload) => {
      state.history = payload;
      localStorage.setItem("history", JSON.stringify(payload));
    },
    HISTORY_REMOVE: state => {
      state.history = "";
      localStorage.removeItem("history");
    },
    TAGS_SET: (state, payload) => {
      state.tags = payload;
    },
    LANGUAGES_SET: (state, payload) => {
      state.languages = payload;
    }
  },
  actions: {
    UPDATE_ALL_LANGUAGE_RELATED({ dispatch }) {
      dispatch("UPDATE_TAGS_LIST");
      dispatch("UPDATE_LANGUAGES_LIST");
    },
    UPDATE_TAGS_LIST({ commit }) {
      axios
        .get(`/tags`)
        .then(resp => {
          commit("TAGS_SET", resp.data);
        })
        .catch(err => {
          console.log(err);
        });
    },
    UPDATE_LANGUAGES_LIST({ commit }) {
      axios
        .get(`/language`)
        .then(resp => {
          commit("LANGUAGES_SET", resp.data);
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  getters: {
    getHistory: state => state.history,
    getTags: state => state.tags,
    getLanguages: state => state.languages
  }
});
